import React, { Component } from "react";
import { Panel } from "react-bootstrap";
import { withRouter } from 'react-router-dom';

import Spinner from "@sm/components/Spinner";
import Table from "@sm/components/custom/Table";

import "@assets/css/apiData.css";

import { DASHBOARD_TOP_UP_REQUEST } from "@sm/actions/types";
import { toFormattedNumber } from "@sm/utils/utils";
import { DATA_TYPES } from "@modules/data/ManualInput";

const store = require("@sm/reducers/index");

class DashBoardTopUpRequestsComponent extends Component {
  constructor(props) {
    super(props);

    this.state = {
      topUpsRequests: undefined,
      loading: true,
      socket: false,

      columns: [
        {
          value: "date",
          label: "Date",
          isNumber: false,
          isDate: true,
          leftAligned: true,
        },
        {
          value: "merchantName",
          label: "Merchant",
          rightAligned: true,
          isNumber: false,
        },
        {
          value: "appId",
          label: "App ID",
          leftAligned: true,
          isNumber: true,
        },
        {
          value: "method",
          label: "Method",
          rightAligned: true,
          isNumber: false,
        },
        {
          value: "currency",
          label: "Currency",
          rightAligned: true,
          isNumber: false,
        },
        {
          value: "amount",
          label: "Amount",
          isNumber: true,
          rightAligned: true,
        },
        {
          value: "id",
          label: "Action",
          centerAligned: true,
          className: "btn view-settlement",
          buttonLabel: "View",
          isButton: true,
          triggerEvent: (data) => this.viewTopUpRequest(data),
          isButtonDisabled: () => { return false; },
          isButtonLoading: () => { return false; }
        }
      ]
    };
  }

  subscribeFunction = null;

  componentDidMount() {
    this.subscribeFunction = store.default.subscribe(() => {
      const state = store.default.getState().dashboardReducer;

      if (state.update === "LOADING") {
        this.setState({ loading: true });
      }

      if (state.update === DASHBOARD_TOP_UP_REQUEST) {
        this.setState({
          topUpsRequests: state.topUpsRequests,
          loading: false
        });
      }
    });
  }

  componentWillUnmount() {
    if (this.subscribeFunction) {
      this.subscribeFunction();
    }
  }

  tableData = () => {
    const { topUpsRequests } = this.state;

    if (!topUpsRequests) {
      return [];
    }

    return topUpsRequests.map((elem) => {
      return {
        id: elem.id,
        date: elem.date,
        merchantName: elem.merchantName,
        appId: elem.merchant,
        method: elem.method.replace('_', ' '),
        currency: elem.currency,
        amount: toFormattedNumber(elem.topUpAmount),
      };
    });
  };

  viewTopUpRequest = (data) => {
    data.merchantId = data.appId;
    this.props.history.push({
      pathname: "/manual-input",
      state: {
        ...data,
        dataType: DATA_TYPES.TOP_UP_PAYOUT_WALLET_BY_REQUEST
      }
    });
  };

  render() {
    const { topUpsRequests, loading, columns } = this.state;

    return (
      <Panel style={ { height: "100%" } }>
        <Panel.Heading>
          <Panel.Title> PENDING TOP UP WALLET REQUESTS </Panel.Title>
        </Panel.Heading>
        <Panel.Body>
          {loading && !topUpsRequests ? (
            <Spinner smallContainer={ true } />
          ) : (
            <div className="panel-content table-content ">
              <Table
                columns={ columns }
                headerColor={ "#DFDFDF" }
                data={ this.tableData() }
              />
            </div>
          )}
        </Panel.Body>
      </Panel>
    );
  }
}

export default withRouter(DashBoardTopUpRequestsComponent);
